export default "__VITE_ASSET__zaNEN65u__"